import angular from "angular"
import moment from "moment"
import routing from "./availabilitystatus.routes"
import { dateAsString } from "../shared/utils"

// todo, get rid of this component and just have the react one

export class AvailabilityStatusComponent {
  /*@ngInject*/
  constructor($scope, $timeout, $http, $q, $state, $stateParams, anytimeService) {
    this.anytimeService = anytimeService
    this.$timeout = $timeout
    this.$http = $http
    this.$q = $q
    this.$stateParams = $stateParams
    this.$scope = $scope
    this.$state = $state
    this.collapseText = "...collapse"
  }

  updateComponent() {
    this.loading = false
    this.startDateAsMoment = moment(this.startDate)
    this.endDateAsMoment = moment(this.endDate)
    this.startDatePresentable = this.getPresentableDate(this.startDateAsMoment)
    this.endDatePresentable = this.getPresentableDate(this.endDateAsMoment)
    this.lengthOfStay = this.endDateAsMoment.diff(this.startDateAsMoment, "days")

    if (this.campsiteinfo.booksystemname === "Anytime") {
      this.anytimeService
        .getMinNightsAndPricing(this.campsiteinfo.name)
        .then((anytimeMinNightsAndPricingDataAllUnits) => {
          const anytimeUnitPriceForDuration = this.anytimeService.getAnytimeUnitPriceForDuration(
            anytimeMinNightsAndPricingDataAllUnits,
            this.startDate,
            this.accomodationType,
            this.lengthOfStay
          )
          this.anytimePriceForUnitTypeString = `£${anytimeUnitPriceForDuration} for ${this.lengthOfStay} nights`
        })
    }
  }

  bookTregartonSpecificAccomodationType = () => {
    let startDateAsMoment = moment(this.startDate).startOf("day")
    let endDateAsMoment = moment(this.endDate).startOf("day")
    const startDateAsString = dateAsString(startDateAsMoment, true)
    const lengthOfStay = endDateAsMoment.diff(startDateAsMoment, "days")
    window.open(
      `https://tregarton.anytimebooking.eu/place_booking/preset/1/${this.accomodationUnitId}/${startDateAsString}/${lengthOfStay}`
    )
  }

  pitchTypeFilterChange = (e) => {
    this.onChangePitchTypeOptions({ checkedState: e })
  }

  getPresentableDate(momentdate) {
    let formatString = "MMM Do"
    if (moment(new Date()).year() !== momentdate.year()) {
      formatString += " YYYY"
    }
    return momentdate.format(formatString)
  }

  $onChanges() {
    this.updateComponent()
  }

  resetComponent() {
    this.loading = true
  }

  $onInit() {
    this.isAnytimeBookingSystem = this.campsiteinfo.booksystemname === "Anytime"
    this.isGemaParkBookingSystem = this.campsiteinfo.booksystemname === "GemaPark"

    this.bookingDetails = {
      bookingSystemType: this.campsiteinfo.booksystemname,
      accomTypeId: this.accomodationType,
      campsiteName: this.campsiteinfo.name,
      endDate: this.endDate,
      gemaparkCompanyId: this.campsiteinfo.gemaparkcid,
      gemaparkParkId: this.campsiteinfo.gemaparkparkid,
      numOfAdults: this.numOfAdults,
      numOfChildren: this.numOfChildren,
      numOfInfants: this.numOfInfants,
      startDate: this.startDate,
    }
  }
}

export default angular
  .module("directives.availabilitystatus", [])
  .config(routing)
  .component("availabilitystatus", {
    template: require("./availabilitystatus.html"),
    controller: AvailabilityStatusComponent,
    bindings: {
      allAnytimeSubUnits: "<",
      accomodationType: "<",
      categoryId: "<",
      accomodationUnitId: "<",
      gemaparkCampsiteId: "<",
      gemaparkParkId: "<",
      campsiteinfo: "<",
      editAvailability: "&",
      onClear: "&",
      selectedMarker: "<",
      startDate: "<",
      endDate: "<",
      pitchTypeOptions: "<",
      unitsData: "<",
      pitchTypeFilterValue: "<",
      onChangePitchTypeOptions: "&",
      unitIdOfFirstFilteredPitch: "<",
      minNumberOfNightsForPitchBookings: "<",
      onHandleClickBookPitchButton: "&",
      onClickPickPitchButton: "&",
      shouldPick: "<",
      availabilityStatusMinimized: "<",
      toggleAvailabilityStatusMinimized: "&",
      numOfAvailableMarkersByType: "<",
      skipIndividualPitchAvailability: "<",
      isPitchBookingLimited: "<",
      isPricingShowing: "<",
      shouldAllPitchesShowRemaining: "<",
      numOfAdults: "<",
      numOfChildren: "<",
      numOfInfants: "<",
    },
  }).name
